export default __webpack_public_path__ + "static/media/gauge.f49b7c99.svg";